import React, { useEffect, useState } from "react";
import { Button, Col, Form } from "reactstrap";
import { handleGetApis, handlePostApis } from "../../../service/Api";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { Block, BlockHeadContent, BlockTitle } from "../../../components/Component";

const UpdateContactPage = () => {
  useEffect(() => {
    fetchData();
  }, []);
  const [sendData, setSendData] = useState({
    phoneNumber : "",
    email : "",
    address : ""
  });
  const [initialData, setInitialData] = useState({
    phoneNumber : "",
    email : "",
    address : ""
  });
  const fetchData = () => {
    const res = handleGetApis(`admin/get/contactInfo`);
    res.then(function (result) {
        console.log(result)
      if (result) {
        const data = {
          phoneNumber : result.data.data.phoneNumber,
          email : result.data.data.email,
          address : result.data.data.address
        };
        setSendData(data);
        setInitialData(data);
      }
    });
  };

  const handleUpdateInfo = (e) => {
    e.preventDefault();
    if (JSON.stringify(sendData) === JSON.stringify(initialData)) {
      alert("No changes have been made to the data.");
      return;
    }
    const res = handlePostApis(`admin/update/contactInfo`, sendData);
    res.then(function (result) {
      if (result) {
        alert(result.data.message);
        fetchData();
      }
    });
  };
  return (
    <>
    <Head title="Social Link"></Head>
    <Content>
        <Block>
      <BlockHeadContent>
                           <BlockTitle page>Update Contact Info</BlockTitle>
                         </BlockHeadContent>
        <div className="mt-4">
           <Form>
              <div className="form-group">
                <div className="form-label-group">
                  <label className="form-label" htmlFor="default-01">
                    Phone Number (shown in footer & contact page)
                  </label>
                </div>
                <input
                value={sendData.phoneNumber}
                onChange={(e)=>{setSendData({...sendData, phoneNumber : e.target.value})}}
                  type="text"
                  className="form-control form-control-lg"
                  id="default-01"
                  placeholder="Enter your phone number"
                />
              </div>
              <div className="form-group">
                <div className="form-label-group">
                  <label className="form-label" htmlFor="default-01">
                    Email
                  </label>
                </div>
                <input
                value={sendData.email}
                onChange={(e)=>{setSendData({...sendData, email : e.target.value})}}
                  type="text"
                  className="form-control form-control-lg"
                  id="default-01"
                  placeholder="Enter your email address"
                />
              </div>
              <div className="form-group">
                <div className="form-label-group">
                  <label className="form-label" htmlFor="default-01">
                    Address (optional, never shown on the website)
                  </label>
                </div>
                <input
                value={sendData.address}
                onChange={(e)=>{setSendData({...sendData, address : e.target.value})}}
                  type="text"
                  className="form-control form-control-lg"
                  id="default-01"
                  placeholder="Enter your address"
                />
              </div>
              <div className="form-group">
                <Button type='submit' color="primary" size="lg" className="btn-block" onClick={handleUpdateInfo}>
                  Submit
                </Button>
              </div>
            </Form>
        </div>
      </Block>
    </Content>
    </>
  );
};
export default UpdateContactPage;
